import { render, staticRenderFns } from "./EmptyPageLayout.vue?vue&type=template&id=169c3354&scoped=true&"
import script from "./EmptyPageLayout.vue?vue&type=script&lang=ts&"
export * from "./EmptyPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyPageLayout.vue?vue&type=style&index=0&id=169c3354&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c3354",
  null
  
)

export default component.exports